import React, { useEffect, useId, useState } from "react";
import tampuuriWindowObject from "../../tampuuriWindowObject";
import accessibility from "../../accessibility";

const SurfaceArea = (props) => {
  const { params, submitParams } = props;
  const { translate } = tampuuriWindowObject();
  const { announceMessage, globalAccessibilitySpeakerId } = accessibility();
  const id = useId();

  const changeSurface = (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    submitParams({ surfaceArea: numericValue });

    announceMessage(
      globalAccessibilitySpeakerId,
      translate("Surface-area is atleast") + numericValue + "m2",
    );
  };

  return (
    <div className="input-wrapper surface-area">
      <label htmlFor={id}>{translate("Pinta-ala vähintään")}</label>
      <input
        onChange={changeSurface}
        placeholder={"Min"}
        type="number"
        id={id}
        name="surface-area"
        value={params.surfaceArea}
      ></input>
    </div>
  );
};

export default SurfaceArea;
